import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { DetailsDrawer, ErrorBoundary, PageLayout } from 'shared-ui';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { AppRoute } from 'routing/AppRoute.enum';
import { useIsExactPath } from 'hooks/useIsExactPath/useIsExactPath';
import { useSelectedUser } from 'hooks/useSelectedUser/useSelectedUser';

import { UsersBar } from './usersBar/UsersBar';
import { UsersListContainer } from './usersList/UsersListContainer';
import { UserDetailsContainer } from './userDetails/UserDetailsContainer';
import { UsersLoginHistoryContainer } from './usersLoginHistory/UsersLoginHistoryContainer';

export const Users = () => {
  const { formatMessage } = useLocale();
  const [usersTableSearchQuery, setUsersTableSearchQuery] = useState('');
  const location = useLocation();
  const isHistoryView = useIsExactPath(AppRoute.usersLoginHistory);
  const { selectedUser } = useSelectedUser();

  const currentPage = {
    [AppRoute.users]: <UsersListContainer usersTableSearchQuery={usersTableSearchQuery} />,
    [AppRoute.usersLoginHistory]: <UsersLoginHistoryContainer />,
  }[location.pathname];

  return (
    <ErrorBoundary>
      <PageLayout
        header={formatMessage({ id: AppMessages['users.title'] })}
        renderContent={() => (
          <>
            <UsersBar setTableSearchQuery={isHistoryView ? undefined : setUsersTableSearchQuery} />

            {currentPage}
          </>
        )}
        renderDetails={() =>
          !isHistoryView && (
            <DetailsDrawer isOpen={!!selectedUser} header={formatMessage({ id: AppMessages['user.details.title'] })}>
              {selectedUser && <UserDetailsContainer selectedUser={selectedUser} />}
            </DetailsDrawer>
          )
        }
      />
    </ErrorBoundary>
  );
};
